export interface Data {
  name: string
  timestamp: string
  value: number
  windowAvg: number
}

export interface AttributeData {
  [key: string]: Data[];
}